import type { Effect, Reducer } from 'umi';

import type { TransferPickOrderTableList } from './data';
import { getTransferPickOrderDetail } from './service';

export interface StateType {
  transferPickOrder?: TransferPickOrderTableList;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    getTransferPickOrder: Effect;
  };
  reducers: {
    saveTransferPickOrder: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'wmsTransferPickModel',
  state: {
    transferPickOrder: undefined,
  },
  effects: {
    *getTransferPickOrder({ payload }, { call, put }) {
      const response = yield call(getTransferPickOrderDetail, payload);
      yield put({
        type: 'saveTransferPickOrder',
        payload: response.data,
      });
    },
  },

  reducers: {
    saveTransferPickOrder(state, action) {
      return {
        ...state,
        transferPickOrder: action.payload,
      };
    },
    clear() {
      return {
        transferPickOrder: undefined,
      };
    },
  },
};

export default Model;
